document.addEventListener('click', function(e) {
  var btn = e.target.closest('.gf-modal-btn, .gf-modal-btn-sec');
  if (!btn || !btn.href || btn.href.indexOf('/cart/add') === -1) return;
  
  e.preventDefault();
  
  var url = new URL(btn.href);
  var id = url.searchParams.get('id');
  var items = [{id: parseInt(id), quantity: 1}];
  
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({items: items})
  })
  .then(function() {
    document.querySelector('.cart-count-bubble') && 
      fetch('/cart.js').then(r => r.json()).then(function(cart) {
        document.querySelectorAll('.cart-count-bubble span').forEach(function(el) {
          el.textContent = cart.item_count;
        });
      });
    document.querySelector('cart-drawer') ? 
      document.querySelector('cart-drawer').open() : 
      window.location.href = '/cart';
  });
});